import React from 'react';
import ChatMessage from '../../chat/ChatMessage';
import Card from '../../common/Card';

/**
 * The performance table or chart of a student's report, drawn by ChatMessage's formatters.
 */
export default function StudentReportPerformanceOverview({ performanceOverview }) {
    if (!performanceOverview) {
        return null;
    }

    const title = typeof performanceOverview === 'object' && performanceOverview.title
        ? performanceOverview.title
        : 'Performance overview';

    // Convert to content string that ChatMessage parseMessageContent handles
    const rawContent = typeof performanceOverview === 'string'
        ? performanceOverview
        : JSON.stringify(performanceOverview);

    return (
        <Card title={title}>
            <ChatMessage
                message={{
                    id: 'performance-overview',
                    content: rawContent,
                    role: 'assistant'
                }}
                fullWidth
                isPlain
                showPdfExport={false}
            />
        </Card>
    );
}
